import { createSlice } from '@reduxjs/toolkit';

const popupSlice = createSlice({
  name: 'popup',
  initialState: {
    isShowGuide: false,
    isShowDifferentTerms: false,
    ProgressPopup: { isShow: false },
  },
  reducers: {
    openGuide: state => {
      state.isShowGuide = true;
    },
    closeGuide: state => {
      state.isShowGuide = false;
    },
    openDifferentTerms: state => {
      state.isShowDifferentTerms = true;
    },
    closeDifferentTerms: state => {
      state.isShowDifferentTerms = false;
    },
    openProgressPopup: state => {
      state.ProgressPopup.isShow = true;
    },
    closeProgressPopup: state => {
      state.ProgressPopup.isShow = false;
    },
  },
});

export const { openGuide, closeGuide, openDifferentTerms, closeDifferentTerms, openProgressPopup, closeProgressPopup } =
  popupSlice.actions;
export default popupSlice.reducer;
